import React from 'react'

import { useShouldHideColors } from './options/_form/PdfOptionsFormHandler'
import Text from './Text'
import { COLORS } from '@btime/constants'

const Tag = ({ color, label }) => {
  const hideColors = useShouldHideColors()

  color = color || COLORS.dark3

  const style = {
    root: {
      backgroundColor: hideColors ? COLORS.transparent : color,
      border: `solid 1px ${hideColors ? COLORS.dark1 : color}`,
      padding: 3,
      borderRadius: 2,
      minWidth: 42
    }
  }
  return (
    <div style={style.root}>
      <Text align="center" size="xsmall" color={COLORS.white} bold noWrap>
        {label}
      </Text>
    </div>
  )
}

export default Tag
